module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/accessibility-A-75ad5fc2421cc99da4ec142ffe65eb2b.svg&quot;;"